import { render, staticRenderFns } from "./TextCodeEditAside.vue?vue&type=template&id=50b7e5ba&"
import script from "./TextCodeEditAside.vue?vue&type=script&lang=js&"
export * from "./TextCodeEditAside.vue?vue&type=script&lang=js&"
import style0 from "./TextCodeEditAside.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports